module.exports = __webpack_public_path__ + "static/media/mask8.ff5d8d0a.JPG";